import React from 'react';
import s from '../../styles/corporate/Corporate.module.css';
import { MARQUEE_WORDS } from './data';
import { usePointerGlow } from './hooks';
import Shot from './Shot';

/** 흐르는 띠 — 끊기지 않게 같은 목록을 두 벌 붙인다 */
const TICKER = [...MARQUEE_WORDS, ...MARQUEE_WORDS];

const CorpHero = ({ onNavigate }) => {
  const glowRef = usePointerGlow();

  return (
    <section className={s.hero} id="top">
      <div className={s.heroArt} aria-hidden="true">
        <Shot file="hero-bg.webp" placeholder="히어로 배경 이미지 (가로형)" eager />
      </div>
      <div className={s.heroScrim} aria-hidden="true" />
      <div className={s.glow} ref={glowRef} aria-hidden="true" />

      <div className={`${s.wrap} ${s.heroInner}`}>
        <div className={s.heroCopy}>
          <h1 className={s.h1}>
            <span className={s.h1Line}>
              <span style={{ animationDelay: '0.1s' }}>기업의 가능성을</span>
            </span>
            <span className={s.h1Line}>
              <span style={{ animationDelay: '0.22s' }}>
                연결하고, <span className={s.gold}>기술로</span>
              </span>
            </span>
            <span className={s.h1Line}>
              <span className={s.gold} style={{ animationDelay: '0.34s' }}>
                미래를 확장합니다.
              </span>
            </span>
          </h1>

          <p className={`${s.heroLead} ${s.reveal}`} data-delay="500">
            오퍼그룹은 AI와 데이터 기술을 기반으로 기업의 성장 가능성을 연결하고, 기업 간 협력과
            혁신을 통해 지속가능한 산업 생태계를 만들어갑니다.
          </p>

          <div className={`${s.heroCtaRow} ${s.reveal}`} data-delay="650">
            <button type="button" className={s.btnDark} onClick={() => onNavigate('about')}>
              <span translate="no">Discover our story ↗</span>
            </button>
            <button type="button" className={s.btnLine} onClick={() => onNavigate('business')}>
              사업영역 보기
            </button>
          </div>
        </div>
      </div>

      <div className={s.ticker} aria-hidden="true">
        <div className={s.tickerTrack} translate="no">
          {TICKER.map((word, i) => (
            <React.Fragment key={`${word}-${i}`}>
              <span>{word}</span>
              <span>·</span>
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CorpHero;
